"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const SpinnerOverlay = ({ children, visible, allWhiteBackground = false }) => {
    const [hide, setHide] = (0, react_1.useState)(!visible);
    const [whiteBackground, setWhiteBackground] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const id = setTimeout(() => {
            setHide(!visible);
        }, 300);
        return () => {
            clearTimeout(id);
        };
    }, [visible, allWhiteBackground]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)('spinner-overlay w-100 h-100 position-absolute', {
                    visible,
                    hidden: hide,
                    whiteBackground: allWhiteBackground,
                }), children: (0, jsx_runtime_1.jsx)("div", { className: "spinner-border text-primary", role: "status", children: (0, jsx_runtime_1.jsx)("span", { className: "visually-hidden", children: "Loading..." }) }) }), children] }));
};
exports.default = SpinnerOverlay;
